import React from "react";
import { useMediaQuery } from "@mui/material";

const Footer = () => {
  const isSmallScreen = useMediaQuery("(max-width: 625px)");

  return (
    <section className="footerMain">
      <div className="footer-m1">
        <div className="footer-m1-heading-container">
          <span className="footer-m1-heading">SERVICES</span>
          <ul className="footer-m1-list">
            <a
              href="https://spanidea.com/embedded-systems-firmware-engineering/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Embedded Systems & Firmware Engineering</li>
            </a>
            <a
              href="https://spanidea.com/silicon-engineering-hardware-design/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Silicon Engineering & Hardware Design</li>
            </a>
            <a
              href="https://spanidea.com/software-product-engineering/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Software Product Engineering</li>
            </a>
            <a
              href="https://spanidea.com/iot-engineering-smart-connectivity/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>IoT Engineering & Smart Connectivity</li>
            </a>
            <a
              href="https://spanidea.com/5g-next-gen-wireless-services/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>5G & Next-Gen Wireless Services</li>
            </a>
            <a
              href="https://spanidea.com/5g-next-gen-wireless-services/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>OpenSync</li>
            </a>
            <a
              href="https://spanidea.com/edge-ai-intelligent-systems/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Edge AI & Intelligent Systems</li>
            </a>
            <a
              href="https://spanidea.com/networking-wi-fi-solutions/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Networking & Wi-Fi Solutions</li>
            </a>
            <a
              href="https://spanidea.com/risc-v-software-engineering/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>RISC-V Software Engineering</li>
            </a>
          </ul>

          <ul className="footer-m1-list-hide">
            <a
              href="https://spanidea.com/application-development-and-modernization/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Application Development and Modernization</li>
            </a>
            <a
              href="https://spanidea.com/cloud-services/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Cloud Services</li>
            </a>
            <a
              href="https://spanidea.com/artificial-intelligence-and-machine-learning/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Artificial Intelligence and Machine Learning</li>
            </a>
            <a
              href="https://spanidea.com/cybersecurity-services/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Cybersecurity Services</li>
            </a>
            <a
              href="https://spanidea.com/digital-transformation-and-strategy-consulting/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Digital Transformation and Strategy Consulting</li>
            </a>
            <a
              href="https://spanidea.com/data-analytics/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Data & Analytics</li>
            </a>
          </ul>
        </div>

        <div className="footer-services-column">
          <span className="footer-m1-heading">
            <br />
          </span>
          <ul className="footer-m1-list">
            <a
              href="https://spanidea.com/application-development-and-modernization/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Application Development and Modernization</li>
            </a>
            <a
              href="https://spanidea.com/cloud-services/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Cloud Services</li>
            </a>
            <a
              href="https://spanidea.com/artificial-intelligence-and-machine-learning/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Artificial Intelligence and Machine Learning</li>
            </a>
            <a
              href="https://spanidea.com/cybersecurity-services/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Cybersecurity Services</li>
            </a>
            <a
              href="https://spanidea.com/digital-transformation-and-strategy-consulting/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Digital Transformation and Strategy Consulting</li>
            </a>
            <a
              href="https://spanidea.com/data-analytics/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Data & Analytics</li>
            </a>
          </ul>
        </div>

        <div>
          <span className="footer-m1-heading">SOLUTIONS</span>
          <ul className="footer-m1-list">
            <a
              href="https://spanidea.com/in/uconnect/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>UConnect</li>
            </a>
            <a
              href="https://spanidea.com/in/umanage/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Umanage</li>
            </a>
            <a
              href="https://spanidea.com/in/andsf/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>ANDSF</li>
            </a>
            <a
              href="https://spanidea.com/in/ucwmp/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>UCWMP</li>
            </a>
            <a
              href="https://spanidea.com/in/silrtos-2-3/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>silRTOS</li>
            </a>
          </ul>
        </div>

        <div>
          <span className="footer-m1-heading">ABOUT US</span>
          <ul className="footer-m1-list">
            <a
              href="https://spanidea.com/company-overview/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Company Overview</li>
            </a>
            <a
              href="https://spanidea.com/awards/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Awards</li>
            </a>
            <a
              href="https://spanidea.com/our-trusted-partners/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Our Trusted Partners</li>
            </a>
            <a
              href="https://spanidea.com/quality-and-iso-certifications/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Quality and ISO Certifications</li>
            </a>
            {/* <a
              href="https://spanidea.com/leadership/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Leadership</li>
            </a> */}
            <a
              href="https://spanidea.com/locations/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <li>Locations</li>
            </a>
          </ul>
        </div>
      </div>

      <div className="footer-m2">
        <div>
          <img src="/Artboard-2.webp" className="footer-m2-img" />
        </div>

        <div>
          <img src="/Artboard-3.webp" className="footer-m2-img" />
        </div>

        <div style={{ display: "flex", alignItems: "center" }}>
          <img src="/iso2.webp" className={"footer-m2-img2"} />
        </div>

        <div>
          <img src="/Artboard-5.webp" className="footer-m2-img" />
        </div>

        <div>
          <img src="/Artboard-4.webp" className="footer-m2-img" />
        </div>
      </div>

      <div className="footer-m3">
        <hr className="footer-m3-line"></hr>
      </div>

      <div className="footer-m4">
        <div className="footer-m4-inner footer-inner">
          <div>
            <img src="/Spanidea--768x134.png" className="spanIdeaLogoFooter" />
          </div>

          <div className="footer-m4-icons">
            <span
              style={{
                width: "32px",
                height: "32px",
                border: "1px solid #0A21C0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#0A21C0",
              }}
            >
              <a
                href="https://www.facebook.com/SpanIdeaSystemsPvtLtd"
                target="_blank"
              >
                <img src="/facebook.svg" />
              </a>
            </span>

            <span
              style={{
                width: "32px",
                height: "32px",
                border: "1px solid #0A21C0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#0A21C0",
              }}
            >
              <a href="https://twitter.com/SpanIdeaSystems/" target="_blank">
                <img src="/twitter.svg" />
              </a>
            </span>

            <span
              style={{
                width: "32px",
                height: "32px",
                border: "1px solid #0A21C0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#0A21C0",
              }}
            >
              <a
                href="https://www.linkedin.com/company/spanidea-systems"
                target="_blank"
              >
                <img src="/linkedin.svg" />
              </a>
            </span>

            <span
              style={{
                width: "32px",
                height: "32px",
                border: "1px solid #0A21C0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#0A21C0",
              }}
            >
              <a
                href="https://www.instagram.com/spanideasystems/"
                target="_blank"
              >
                <img src="/instagram.svg" />
              </a>
            </span>

            <span
              style={{
                width: "32px",
                height: "32px",
                border: "1px solid #0A21C0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#0A21C0",
              }}
            >
              <a href="https://www.youtube.com/@spanideasystem" target="_blank">
                <img src="/youtube.png" />
              </a>
            </span>
          </div>
        </div>

        <div className="footer-m4-inner">
          <div className="footer-text">
            <span>
              ©{new Date().getFullYear()}. SpanIdea. All Rights Reserved.
            </span>
          </div>

          <div className="footer-m4-text">
            <a
              href="https://spanidea.com/in/terms-conditions/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <div>Terms & Conductions</div>
            </a>
            <a
              href="https://spanidea.com/in/privacy-policy/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <div>Privacy Policy</div>
            </a>
            <a
              href="https://spanidea.com/in/cookies-policy/"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
              onMouseEnter={(e) => (
                (e.target.style.color = "#165dff"),
                (e.target.style.textDecorationColor = "rgb(56, 196, 236)")
              )}
              onMouseLeave={(e) => (
                (e.target.style.color = "white"),
                (e.target.style.textDecoration = "none")
              )}
            >
              <div>Cookie Policy</div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
